<template>
    <div class="orders">
        <order v-for="order in openOrders" :key="order.id" :order="order" :history=false></order>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters} from 'vuex'
    import Order from './Order'

    export default {
        name: 'Orders',
        components: {
            Order,
        },
        data() {
            return {
                menuVisible: false,
                searchTerm: ''
            }
        },
        computed: {
            ...mapGetters('dashboard', [
                'location',
                'filterNumber'
            ]),
            openOrders: function () {
                if (this.filterNumber) {
                    return this.location.orders.filter(order => (!order.picked_up && !order.canceled && order.payment_transaction_id && order.pick_up_number == this.filterNumber))
                } else {
                    return this.location.orders.filter(order => (!order.picked_up && !order.canceled && order.payment_transaction_id))
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .orders {
        height: 100%;
        display: flex;
        justify-content: left;
        overflow: auto;
        padding: 15px 0;
    }
</style>
